var map = {
	"./btn_close_w.svg": "981f",
	"./btn_count.svg": "ac81",
	"./btn_funSet.svg": "08c6",
	"./first.svg": "1090",
	"./icon_edit.svg": "bb16",
	"./icon_noGame.svg": "79a7",
	"./icon_noReceipt.svg": "6cba",
	"./icon_onInfo.svg": "60d7",
	"./icon_star.svg": "e966",
	"./member.svg": "7b3d",
	"./password.svg": "eb92",
	"./setting.svg": "776b",
	"./sun.svg": "fa8d",
	"./sun1.svg": "fd3b",
	"./up.svg": "50fc",
	"./yue.svg": "422f",
	"./yue1.svg": "4081"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a213";